export const experienceData = [
  {
    id: 1,
    company: 'Maersk',
    jobtitle: 'Software Engineer',
    startYear: 'Sep 2025',
    endYear: 'Present',
    link: 'https://www.linkedin.com/company/maersk-group/',
    logo: 'https://banner2.cleanpng.com/20180704/vf/aaxs5b3k5.webp',
    data: [
      `For the Finance Portal, delivering scalable and high-performing features used globally.`,
      `Implemented end-to-end Used Credits flow, reducing customer incidents significantly.`,
    ],
  },
  {
    id: 2,
    company: 'Maersk',
    jobtitle: 'Associate Software Engineer',
    startYear: 'July 2024',
    endYear: 'Sep 2025',
    link: 'https://www.linkedin.com/company/maersk-group/',
    logo: 'https://banner2.cleanpng.com/20180704/vf/aaxs5b3k5.webp',
    data: [
      `Improved test coverage by 12+% and reduced CI run time by implementing parallel pipelines.`,
      `Migrated critical codebase to TypeScript and resolved 60+ SonarQube issues, enhancing type safety and code quality.`,
      `Designed and launched an AI-powered PDF summarization feature, enabling customers to quickly extract key insights from financial documents and reducing support queries.`,
      `Integrated a notification flow, reducing customer contacts by 10% and saving 8+ FTEs.`,
    ],
  },
  {
    id: 3,
    company: 'Omnipractice',
    jobtitle: 'Software Engineer',
    startYear: 'Jun 2023',
    endYear: 'July 2024',
    link: 'https://www.linkedin.com/company/omnipractice/',
    data: [
      `Actively contributing to the development of a mental health care
website and EHR platform, ensuring clean code architecture and adherence to industry best practices.
`,
      `Engineered an efficient Gmail import system using API integration from Gmail API, optimizing for minimal delay (approx. 1 second), enhancing data import efficiency.
`,
      `Developed and implemented a comprehensive form and notes builder,
offering advanced features comparable to Google Forms creation.
`,
      `Designed and deployed a secure passwordless sign-in system, improving user authentication.`,
      `Architected and integrated Stripe Express onboarding for payment
flow, enhancing user experience and ensuring secure transactions.`,
    ],
  },
  //   {
  //     id: 2,
  //     company: 'LotusCloud',
  //     jobtitle: 'Software Engineer Intern',
  //     startYear: 'Jun 2022',
  //     endYear: 'Jun 2023',
  //     link: 'https://www.linkedin.com/company/lotuscloud/',
  //     data: [
  //       `Designed and implemented multiple reusable components, including
  // a multi-selector dropdown, slot picker, calendar, and a custom infinite
  // scroll component.
  // `,
  //       `
  // Developed multiple reusable hooks and setup an EHR product reposi-
  // tory from scratch with routing and all.
  // `,
  //       `
  // Improving user experience by creating a responsive multi-step form
  // for the onboarding flow of candidates, interviewers, and employers,
  // and integrating a booking widget.`,
  //     ],
  //   },
];
